import React from "react";
import ScfoButton from "src/components/shared/ScfoButton";

export default function Button({
  content,
  fullSize,
  halfSize,
  thirdSize,
  bold,
  font,
  onOk,
  secondary,
  disabled,
  third,
  botMarg,
}) {
  let variant = "success";
  if (secondary) variant = "secondary";
  if (third) variant = "ghost";

  const widthClass = fullSize
    ? "fullSize "
    : halfSize
    ? "halfSize "
    : thirdSize
    ? "thirdSize "
    : " ";

  return (
    <ScfoButton
      type="button"
      variant={variant}
      disabled={disabled}
      className={`${widthClass}${bold ? "bolder " : ""}btn mt-3 d-flex justify-content-center align-items-center`.trim()}
      style={{ fontSize: font ? font : "", marginBottom: botMarg }}
      onClick={() => onOk && onOk()}
    >
      {content}
    </ScfoButton>
  );
}
